export interface BatchMenuItem {
  menuTitle: string
  key: string
  menuInfos: BatchMenuItemMenuInfo[]
}

export interface BatchMenuItemMenuInfo {
  itemsName: string
  items: {
    name: string
    key: string
    downloadable: boolean
  }[]
}

export const LendInfoExtractionKey: string = 'lend-info-extraction'

export const ReturnInfoExtractionKey: string = 'return-info-extraction'

export const ReserveInfoExtractionKey: string = 'reserve-info-extraction'

export const ReserveInfoExtractionCsvKey: string = 'reserve-info-extraction-csv'

export const BatchMenuBibliographyRegisterItem: BatchMenuItem = {
  menuTitle: '書誌登録',
  key: 'bibliography-register',
  menuInfos: [
    {
      itemsName: 'TRC',
      items: [
        {
          name: 'TRC図書・AV登録',
          key: 'trc-books-and-av-register',
          downloadable: false
        },
        {
          name: 'TRC図書・AV更新',
          key: 'trc-books-and-av-update',
          downloadable: false
        },
        // {
        //   name: '発注管理MARC登録',
        //   key: 'order-marc-register',
        //   downloadable: false
        // }
        {
          name: 'TRC内容細目登録',
          key: 'trc-content-detail-register',
          downloadable: false
        },
        {
          name: 'TRC内容細目更新',
          key: 'trc-content-detail-update',
          downloadable: false
        },
        {
          name: 'TRC典拠情報登録',
          key: 'trc-authority-register',
          downloadable: false
        },
        {
          name: 'TRC典拠情報更新',
          key: 'trc-authority-update',
          downloadable: false
        },
        {
          name: 'TRC目次情報登録',
          key: 'trc-contents-data-register',
          downloadable: false
        },
        {
          name: 'TRC目次情報更新',
          key: 'trc-contents-data-update',
          downloadable: false
        }
        // {
        //   name: 'TRC新刊自動発注',
        //   key: 'trc-new-book-automatic-order',
        //           downloadable: false
        // }
      ]
    },
    {
      itemsName: 'MARC変換・登録',
      items: [
        {
          name: 'トーハンマーク登録',
          key: 'tohan-mark-register',
          downloadable: false
        }
        // {
        //   name: 'DC-NDL登録',
        //   key: 'dc-ndl-register',
        //           downloadable: false
        // },
        // {
        //   name: 'オリコンマーク登録',
        //   key: 'oricon-marc-register',
        //           downloadable: false
        // }
      ]
    },
    // {
    //   itemsName: '内容細目変換・登録',
    //   items: [
    //     {
    //       name: 'トーハン内容細目登録',
    //       key: 'tohan-content-detail-register',
    //           downloadable: false
    //     }
    //   ]
    // },
    {
      itemsName: 'AVライブラリMARC登録・変換',
      items: [
        {
          name: 'AVライブラリ登録',
          key: 'av-library-marc-register',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'NRC-MARC(カタログ部)登録・変換',
      items: [
        {
          name: 'NRC-MARC(カタログ部)登録',
          key: 'nrc-marc-catalog-register',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'NRC-MARC(曲目部)登録・変換',
      items: [
        {
          name: 'NRC-MARC(曲目部)登録',
          key: 'nrc-marc-content-register',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'NHK-MARC登録・変換',
      items: [
        {
          name: 'NHK-MARC登録',
          key: 'nhk-marc-register',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '書誌・所蔵データ',
      items: [
        {
          name: 'エクスポート',
          key: 'bibliography-collection-export',
          downloadable: false
        },
        {
          name: 'インポート',
          key: 'bibliography-collection-import',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuInventoryItem: BatchMenuItem = {
  menuTitle: '目録',
  key: 'inventory',
  menuInfos: [
    {
      itemsName: '一覧目録',
      items: [
        {
          name: '一覧目録',
          key: 'list-inventory',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuOrderAcceptItem: BatchMenuItem = {
  menuTitle: '発注受入',
  key: 'order-accept',
  menuInfos: [
    {
      itemsName: 'トーハン',
      items: [
        {
          name: 'トーハン図書発注データ作成',
          key: 'tohan-books-order-data-create',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'TRC',
      items: [
        {
          name: 'TRC図書発注データ作成',
          key: 'trc-books-order-data-create',
          downloadable: false
        },
        {
          name: 'TRC受入MARC登録',
          key: 'trc-accept-marc-register',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '一覧',
      items: [
        {
          name: '発注一覧',
          key: 'order-list',
          downloadable: false
        },
        {
          name: '新着速報',
          key: 'new-breaking-news',
          downloadable: false
        },
        // {
        //   name: '納品一覧・状況リスト',
        //   key: 'delivery-and-situation-list',
        //           downloadable: false
        // },
        // {
        //   name: '未納品一覧・状況リスト',
        //   key: 'undelivered-and-situation-list',
        //           downloadable: false
        // },
        {
          name: '受入原簿',
          key: 'accept-ledger',
          downloadable: false
        }
        // {
        //   name: '欠号資料一覧',
        //   key: 'missing-number-collection-list',
        //           downloadable: false
        // },
        // {
        //   name: '長期延滞資料購入候補リスト',
        //   key: 'long-over-due-collection-purchase-candidate-list',
        //           downloadable: false
        // },
        // {
        //   name: '選定候補一覧',
        //   key: 'selection-candidate-list',
        //           downloadable: false
        // }
      ]
    }
  ]
}

export const BatchMenuCollectionManagementItem: BatchMenuItem = {
  menuTitle: '蔵書管理',
  key: 'collection-management',
  menuInfos: [
    {
      itemsName: '資料情報変更',
      items: [
        {
          name: '所蔵データ一括除籍',
          key: 'collection-bulk-removal',
          downloadable: false
        },
        {
          name: '書誌・資料データ一括削除',
          key: 'bibliography-and-collection-bulk-removal',
          downloadable: false
        },
        {
          name: '書誌データ一括削除',
          key: 'bibliography-bulk-removal',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '資料状態別リスト',
      items: [
        {
          name: '資料状態別リスト',
          key: 'list-by-collection-status',
          downloadable: false
        },
        // {
        //   name: '移管資料一覧',
        //   key: 'transfer-collection-list',
        //   downloadable: false
        // },
        {
          name: '除籍資料一覧',
          key: 'removal-collection-list',
          downloadable: false
        }
        // {
        //   name: '無効資料一覧',
        //   key: 'invalid-collection-list',
        //   downloadable: false
        // },
        // {
        //   name: '予約回送中資料一覧',
        //   key: 'reserve-in-transit-collection-list',
        //   downloadable: false
        // },
        // {
        //   name: '他館回送中資料一覧',
        //   key: 'another-facility-in-transit-collection-list',
        //   downloadable: false
        // }
      ]
    }
    // {
    //   itemsName: '書誌資料情報出力',
    //   items: [
    //     {
    //       name: '書誌資料情報出力',
    //       key: 'bibliography-collection-info-output',
    //       downloadable: false
    //     }
    //   ]
    // },
    // {
    //   itemsName: '不明資料数統計',
    //   items: [
    //     {
    //       name: '不明資料数統計',
    //       key: 'unknown-collection-statistics',
    //       downloadable: false
    //     }
    //   ]
    // }
  ]
}

export const BatchMenuReminderItem: BatchMenuItem = {
  menuTitle: '督促',
  key: 'reminder',
  menuInfos: [
    {
      itemsName: '督促一覧',
      items: [
        {
          name: '督促一覧',
          key: 'reminder-list',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '督促はがき',
      items: [
        {
          name: '督促はがき',
          key: 'reminder-postcard',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '督促手紙',
      items: [
        {
          name: '督促手紙',
          key: 'reminder-letter',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '督促メール',
      items: [
        {
          name: '督促メール',
          key: 'reminder-mail',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuUserManagementItem: BatchMenuItem = {
  menuTitle: '利用者管理',
  key: 'user-management',
  menuInfos: [
    {
      itemsName: '利用者登録',
      items: [
        {
          name: '利用者データ登録',
          key: 'user-data-register',
          downloadable: false
        },
        {
          name: '住基データ登録',
          key: 'basic-residents-data-register',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'リスト出力',
      items: [
        {
          name: '利用者一覧',
          key: 'user-list',
          downloadable: false
        },
        {
          name: 'データ不足利用者一覧',
          key: 'data-shortage-user-list',
          downloadable: false
        },
        {
          name: '有効期限切れ利用者一覧',
          key: 'expired-user-list',
          downloadable: false
        },
        {
          name: '利用者除籍',
          key: 'user-removal',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuLendReturnReserveItem: BatchMenuItem = {
  menuTitle: '貸出返却予約',
  key: 'lend-return-reserve',
  menuInfos: [
    {
      itemsName: '貸出返却DB更新',
      items: [
        {
          name: '返却ＤＢ更新',
          key: 'return-db-update',
          downloadable: false
        },
        {
          name: '貸出ＤＢ更新',
          key: 'lend-db-update',
          downloadable: false
        },
        {
          name: '貸出情報抽出',
          key: LendInfoExtractionKey,
          downloadable: false
        },
        {
          name: '返却情報抽出',
          key: ReturnInfoExtractionKey,
          downloadable: false
        },
        {
          name: '予約情報抽出',
          key: ReserveInfoExtractionKey,
          downloadable: true
        },
        {
          name: '予約情報抽出(CSV)',
          key: ReserveInfoExtractionCsvKey,
          downloadable: true
        }
      ]
    },
    {
      itemsName: '一覧',
      items: [
        {
          name: '貸出資料一覧',
          key: 'lend-collection-list',
          downloadable: false
        },
        // {
        //   name: '借用資料一覧',
        //   key: 'borrowed-collection-list',
        //           downloadable: false
        // },
        {
          name: '予約資料一覧',
          key: 'reserve-collection-list',
          downloadable: false
        },
        // {
        //   name: '予約返却待資料一覧',
        //   key: 'reserve-return-waiting-collection-list',
        //           downloadable: false
        // },
        {
          name: '予約利用者一覧',
          key: 'reserve-user-list',
          downloadable: false
        }
        // {
        //   name: '貸出回数別資料一覧',
        //   key: 'collection-list-by-lend-books-count',
        //           downloadable: false
        // },
        // {
        //   name: '予約在架資料一覧',
        //   key: 'reserve-standing-collection-list',
        //           downloadable: false
        // }
      ]
    },
    {
      itemsName: 'リスト出力',
      items: [
        {
          name: '予約返却待資料回送候補リスト',
          key: 'reserve-return-waiting-collection-forwarding-candidate-list',
          downloadable: false
        },
        {
          name: '在架予約確認リスト',
          key: 'on-shelf-reserve-list',
          downloadable: false
        },
        {
          name: '予約キャンセルリスト',
          key: 'reserve-cancel-list',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '予約連絡',
      items: [
        // {
        //   name: '予約連絡はがき',
        //   key: 'reserve-contact-postcard-user',
        //           downloadable: false
        // },
        // {
        //   name: '予約連絡はがき（日付）',
        //   key: 'reserve-contact-postcard-date',
        //           downloadable: false
        // },
        {
          name: '予約連絡メール',
          key: 'reserve-contact-mail',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '強制返却',
      items: [
        {
          name: '強制返却',
          key: 'forced-return',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuStatisticsItem: BatchMenuItem = {
  menuTitle: '統計',
  key: 'statistics',
  menuInfos: [
    {
      itemsName: '統計',
      items: [
        {
          name: '貸出統計',
          key: 'lend',
          downloadable: false
        },
        {
          name: '配架区分指定貸出統計',
          key: 'select-shelf-lend-statistics',
          downloadable: false
        },
        // {
        //   name: 'パック貸出統計',
        //   key: 'pack-lend-statistics',
        //           downloadable: false
        // },
        {
          name: '予約統計',
          key: 'reserve-statistics',
          downloadable: false
        },
        // {
        //   name: '返却統計',
        //   key: 'return-statistics',
        //           downloadable: false
        // },
        {
          name: '登録者数統計',
          key: 'registrant-statistics',
          downloadable: false
        },
        {
          name: '蔵書/除籍統計',
          key: 'collection-and-removal-statistics',
          downloadable: false
        },
        {
          name: 'レファレンス/コピー/催し物統計',
          key: 'reference-and-copy-and-entertainment-statistics',
          downloadable: false
        },
        // {
        //   name: '公共図書館調査票統計',
        //   key: 'public-library-questionnaire-statistics',
        //           downloadable: false
        // },
        {
          name: '日報出力',
          key: 'daily-statistics-output',
          downloadable: false
        },
        {
          name: '月次統計一括出力',
          key: 'monthly-statistics-output',
          downloadable: false
        },
        {
          name: '年度統計出力',
          key: 'yearly-statistics-output',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'ベストリーダ',
      items: [
        {
          name: 'ベストリーダ',
          key: 'best-reader',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '予約ベスト',
      items: [
        {
          name: '予約ベスト',
          key: 'reserve-best',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuSelectionBookItem: BatchMenuItem = {
  menuTitle: '選書',
  key: 'selection-book',
  menuInfos: [
    {
      itemsName: '選書・書誌一覧',
      items: [
        {
          name: '選書・書誌一覧',
          key: 'selection-book-and-bibliography-list',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '選書・発注一覧',
      items: [
        {
          name: '選書・発注一覧',
          key: 'selection-book-and-order-list',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '選書・発注状況',
      items: [
        {
          name: '選書・発注状況',
          key: 'selection-book-and-order-situation',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuMailSendItem: BatchMenuItem = {
  menuTitle: 'メール送信',
  key: 'mail-send',
  menuInfos: [
    {
      itemsName: 'メール送信',
      items: [
        {
          name: 'お知らせメール送信',
          key: 'mail-send',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuSchoolStatisticsItem: BatchMenuItem = {
  menuTitle: '学校図書館用',
  key: 'school-statistics',
  menuInfos: [
    {
      itemsName: '統計',
      items: [
        {
          name: '貸出統計',
          key: 'lend',
          downloadable: false
        }
      ]
    },
    {
      itemsName: 'ベストリーダ',
      items: [
        {
          name: 'ベストリーダ',
          key: 'best-reader',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '一覧',
      items: [
        {
          name: '貸出資料一覧',
          key: 'lend-collection-list',
          downloadable: false
        },
        {
          name: '利用者一覧',
          key: 'user-list',
          downloadable: false
        }
      ]
    },
    {
      itemsName: '年次処理',
      items: [
        // TODO 実装予定
        // {
        //   name: '卒業処理',
        //   key: 'graduation',
        //   downloadable: false
        // },
        // {
        //   name: '卒業生・転校生一括削除',
        //   key: 'graduate-and-transfer-student-bulk-delete',
        //   downloadable: false
        // },
        {
          name: '進級処理',
          key: 'advancement',
          downloadable: false
        },
        {
          name: '新入生登録',
          key: 'new-student-registration',
          downloadable: false
        }
      ]
    }
  ]
}

export const BatchMenuItems: BatchMenuItem[] = [
  BatchMenuBibliographyRegisterItem,
  // BatchMenuInventoryItem,
  BatchMenuOrderAcceptItem,
  BatchMenuCollectionManagementItem,
  BatchMenuReminderItem,
  BatchMenuUserManagementItem,
  BatchMenuLendReturnReserveItem,
  BatchMenuStatisticsItem,
  // BatchMenuSelectionBookItem
  BatchMenuMailSendItem,
  BatchMenuSchoolStatisticsItem
]
